export interface UsersReportRow {
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  occupation: string;
  profilePicURL: string;
  isDeleted: boolean;
  userBio: string;
  lastLoginAt: string;
  appVersion: string;
  associateNames: string;
  associatesCount: number;
  schedulerNames: string;
  schedulersCount: number;
  dmThreadsCount: number;
  jobsWorkedCount: number;
  jobsInvitedTotalCount: number;
}

export interface UsersReportColumn {
  key: keyof UsersReportRow;
  label: string;
}

export const USERS_REPORT_COLUMNS: UsersReportColumn[] = [
  { key: "uid", label: "uid" },
  { key: "firstName", label: "first name" },
  { key: "lastName", label: "last name" },
  { key: "email", label: "email" },
  { key: "company", label: "company" },
  { key: "occupation", label: "occupation" },
  { key: "profilePicURL", label: "profilePicURL" },
  { key: "isDeleted", label: "isDeleted" },
  { key: "userBio", label: "userBio" },
  { key: "lastLoginAt", label: "last login" },
  { key: "appVersion", label: "app version" },
  { key: "associateNames", label: "associate names" },
  { key: "associatesCount", label: "associates count" },
  { key: "schedulerNames", label: "scheduler names" },
  { key: "schedulersCount", label: "schedulers count" },
  { key: "dmThreadsCount", label: "dm threads count" },
  { key: "jobsWorkedCount", label: "jobs worked count" },
  { key: "jobsInvitedTotalCount", label: "jobs invited total count" },
];
